/* istanbul ignore file */
import {TIME} from './utils/constant';

function onMount(opts) {
  const w = window;
  if (w.performance) {
    if (w.performance.clearMarks) {
      w.performance.clearMarks('mark-react-mounted');
    }
    if (w.performance.mark) {
      w.performance.mark('mark-react-mounted');
    }

    setTimeout(() => {
      const {logger} = opts;
      const gr = opts.globalRegistry;
      const storeId = gr && gr.getStoreId();
      const ua = navigator.userAgent;

      const marks = w.performance.getEntriesByType && w.performance.getEntriesByType('mark');
      const paints = w.performance.getEntriesByType && w.performance.getEntriesByType('paint');
      let results = {
        tag: 'perf',
        storeId,
        url: w.location.pathname,
        userAgent: ua.toString(),
      };
      results =
        marks &&
        marks.reduce((r, item) => {
          r[item.name] = item.startTime;

          return r;
        }, results);

      results =
        paints &&
        paints.reduce((r, item) => {
          r[item.name] = item.startTime;

          return r;
        }, results);
      logger.info(results);
    }, TIME.FIVE_THOUSAND);
  }
}

export default onMount;
